<template>
  <div class="page">
    <div>
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1" title="查询条件">
          <van-field v-model="queryFormModel.no" :colon="true" label="订单号" placeholder="请输入订单号" type="digit"/>
          <van-field v-model="queryFormModel.keyword" :colon="true" label="店员" placeholder="请输入店员ID或店员名称"/>
          <div class="flex justify-center margin-tb-xs">
            <van-button size="large" type="info" @click="onLoad(true)">查询</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index"
           style="margin: 10px 10px;background-color: #fff;border-radius:10px;padding: 5px">
        <div class="top flex align-center justify-between">
          <span><van-icon name="orders-o" size="16px"/> {{ item.no }}</span>
          <van-tag v-if="item.status == 0" plain type="warning">待付款</van-tag>
          <van-tag v-if="item.status == 1" plain type="primary">已付款</van-tag>
          <van-tag v-if="item.status == 2" plain type="success">已完成</van-tag>
        </div>
        <div class="middle" size="large" @click="gotoDetail(item.id)">
          <div class="clerk-item">
            <div class="left">
              <div class="left-head">
                <van-image round width="70px" height="70px" :src="item.avatarUrl"></van-image>
              </div>
              <div class="left-content">
                <!--名称 -->
                <div class="clerkName">
                  <span>{{ item.name }}</span>
                </div>
                <!-- 详情 -->
                <div class="details">
                  <div>
                    <template v-if="item.status==0 || item.status==1 ">下单时间：{{formatDate(item.createTime, 'YYYY-MM-DD HH:mm:ss') }}</template>
                    <template v-if="item.status==2">结束时间：{{formatDate(item.finishTime, 'YYYY-MM-DD HH:mm:ss') }}</template>
                  </div>
                  <div v-if="item.type === 'course'">订单内容：{{item.detail.itemName + '-' + item.detail.name}}</div>
                  <div v-else>订单内容：{{(item.userId ? '赠送' : '') + item.detail.itemName + '-' + item.detail.dayNum + '天'}}</div>
                  <div>订单金额：{{ formatPrice(item.payAmount) }}</div>
                </div>
              </div>
            </div>
            <div class="right">
            </div>
          </div>
        </div>
      </div>

    </van-list>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Button,
  List,
  Cell,
  CellGroup,
  Tag,
  Dialog,
  Collapse,
  CollapseItem,
  Field,
  Popup,
  Image,
  Icon,
  Checkbox, CheckboxGroup, Toast
} from 'vant';
import moment from 'moment';
import Decimal from 'decimal.js';
import {getOrderList} from '@/api/kf/clerk-order';

Vue.use(Button)
    .use(List)
    .use(Cell)
    .use(CellGroup)
    .use(Tag)
    .use(Dialog)
    .use(Image)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Collapse)
    .use(CollapseItem)
    .use(Field)
    .use(Popup)
    .use(Icon)
    .use(Toast)

export default {
  name: 'clerk-order-list',
  components: {},
  data() {
    return {
      activeNames: [1],
      queryFormModel: {
        no: null,
        keyword: null
      },
      list: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10
    }
  },
  computed: {
  },
  watch:{
    '$route' () {
      //当路由发生变化，刷新页面
      this.onLoad(true)
    }
  },
  methods: {
    //跳转页面
    gotoDetail(id) {
      this.$router.push('/kf/order/clerk-order-detail/' + id)
    },
    //加载数据
    onLoad(resetPage) {
      this.activeNames = []
      this.loading = true
      if (resetPage) {
        this.pageNo = 1;
        this.list = []
      }
      let {
        no,
        keyword
      } = this.queryFormModel
      getOrderList(
          no,
          keyword,
          this.pageNo,
          this.pageSize).then(res => {
        this.loading = false;
        const data = res.data;
        if (data.code === 0) {
          if (data.hasNextPage) {
            this.listFinished = false;
          } else {
            this.listFinished = true;
          }
          for (let i in data.list) {
            let user = data.list[i];
            this.list.push(user)
          }
        } else {
          this.listFinished = true;
          Dialog.alert({
            title: '加载订单失败',
            message: data.msg
          })
        }
        this.pageNo++;
      })
    },
    //计算公式
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
  },
  mounted() {
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>
.page{
  background-color: #f6f6f8;
  .top {
    padding: 5px 10px;
  }
  .middle {
    padding: 0 10px;
    margin: 5px;
    .clerk-item {
      display: flex;
      align-items: center;

      .left {
        flex: 1;
        display: flex;

        .left-head {
          margin-right: 10px;
        }

        .left-content {
          .clerkName {
            font-size: 14px;
            font-weight: bold;
          }

          .details {
            margin: 5px 0;
            height: 16px;
            line-height: 16px;
            font-size: 12px;
            color: #999999;
          }
        }
      }

      .right {
        text-align: right;
        min-width: 30px;

        .total-amount {
          color: #333;
        }
      }
    }
  }
  .bottom {
    padding: 0px 0px 5px;
  }
}



</style>
